var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tabs"},[_c('div',{staticClass:"relative"},[_vm._t("default",null,{"toggle":_vm.toggle,"active":_vm.active,"opened":_vm.opened}),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[_vm._t("items",null,{"active":_vm.active,"opened":_vm.opened,"close":_vm.close})],2)],2)])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ed81067a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/Tabs/Wrapper.vue
// module id = UMKS
// module chunks = 115 116